import tw, { TwStyle } from 'twin.macro'
import { useEffect, useId, useRef, useState } from 'react'
import { useLocation } from '@reach/router'
import LabelFloating from './label-floating'

export interface TextFieldProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string
  name: string
  initialValue?: string
  onUpdate?: (arg: string, ref?: HTMLInputElement) => string | void
  tooltip?: string
  fieldsetCss?: TwStyle
  labelCss?: TwStyle
}

export default function TextField(props: TextFieldProps): JSX.Element {
  const { autoFocus, label, initialValue, value, onUpdate, tooltip, fieldsetCss, labelCss, css, ...inputProps } = props

  const ref = useRef<HTMLInputElement>()
  const uid = useId()
  const { search } = useLocation()

  const [hasFocus, setFocus] = useState(false)
  const [input, setInput] = useState(initialValue || (value as string))

  useEffect(() => {
    autoFocus && ref.current?.focus()

    const defVal = new URLSearchParams(search).get(inputProps.name) || (initialValue as string)
    if (defVal) setInput(defVal)
  }, [])

  useEffect(() => {
    if (value && value !== input) setInput(value as string)
  }, [value])
  return (
    <LabelFloating
      label={label}
      uid={uid}
      hasFocus={hasFocus}
      hasInput={input?.length > 0}
      required={inputProps.required}
      name={inputProps.name}
      tooltip={tooltip}
      fieldsetCss={fieldsetCss}
      labelCss={labelCss}
    >
      <input
        ref={ref}
        id={uid}
        value={input}
        onChange={(event) => {
          let updatedValue: string | undefined
          if (onUpdate) updatedValue = onUpdate(event.target.value, ref.current) || event.target.value
          setInput(updatedValue || event.target.value)
        }}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        css={[tw`h-11 lg:h-14 px-3 py-2 text-indigoBlue text-lg w-full outline-none! truncate bg-inherit`, css]}
        aria-required={inputProps.required ? 'true' : 'false'}
        {...inputProps}
      />
    </LabelFloating>
  )
}
